export default __webpack_public_path__ + "static/media/appqm.b850aae8.png";